import { render, staticRenderFns } from "./pro-link-stat-data-list.vue?vue&type=template&id=05c4f692"
import script from "./pro-link-stat-data-list.vue?vue&type=script&lang=js"
export * from "./pro-link-stat-data-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports